import { getHeaderModel } from "../../../../api/headerApi";
import { useQuery } from "@tanstack/react-query";

export const useHeaderModel = ( currentPageId: string ) => {
  return useQuery({
    queryKey: ["redesign-header"],
    queryFn: () => getHeaderModel(currentPageId),
    staleTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
  });
}